/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedStaffRouteImport } from './routes/_authed/_staff'
import { Route as AuthedContractorRouteImport } from './routes/_authed/_contractor'
import { Route as AuthedAdminRouteImport } from './routes/_authed/_admin'
import { Route as AuthedStaffTimesheetsRouteImport } from './routes/_authed/_staff/timesheets'
import { Route as AuthedStaffReportsRouteImport } from './routes/_authed/_staff/reports'
import { Route as AuthedStaffContractorsRouteImport } from './routes/_authed/_staff/contractors'
import { Route as AuthedStaffClientsRouteImport } from './routes/_authed/_staff/clients'
import { Route as AuthedStaffChaseRouteImport } from './routes/_authed/_staff/chase'
import { Route as AuthedContractorMyTimesheetRouteImport } from './routes/_authed/_contractor/my-timesheet'
import { Route as AuthedContractorMySubmissionsRouteImport } from './routes/_authed/_contractor/my-submissions'
import { Route as AuthedContractorMyInvoicesRouteImport } from './routes/_authed/_contractor/my-invoices'
import { Route as AuthedContractorMyCalendarRouteImport } from './routes/_authed/_contractor/my-calendar'
import { Route as AuthedAdminSettingsRouteImport } from './routes/_authed/_admin/settings'
import { Route as AuthedAdminPaymentsRouteImport } from './routes/_authed/_admin/payments'
import { Route as AuthedAdminInvoicesRouteImport } from './routes/_authed/_admin/invoices'
import { Route as AuthedAdminExpensesRouteImport } from './routes/_authed/_admin/expenses'
import { Route as AuthedAdminAdminsRouteImport } from './routes/_authed/_admin/admins'
import { Route as AuthedStaffProjectsIdRouteImport } from './routes/_authed/_staff/projects.$id'
import { Route as AuthedAdminInvoicesIdRouteImport } from './routes/_authed/_admin/invoices_.$id'
import { Route as AuthedAdminExpensesIdRouteImport } from './routes/_authed/_admin/expenses_.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStaffRoute = AuthedStaffRouteImport.update({
  id: '/_staff',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedContractorRoute = AuthedContractorRouteImport.update({
  id: '/_contractor',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStaffTimesheetsRoute = AuthedStaffTimesheetsRouteImport.update({
  id: '/timesheets',
  path: '/timesheets',
  getParentRoute: () => AuthedStaffRoute,
} as any)
const AuthedStaffReportsRoute = AuthedStaffReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedStaffRoute,
} as any)
const AuthedStaffContractorsRoute = AuthedStaffContractorsRouteImport.update({
  id: '/contractors',
  path: '/contractors',
  getParentRoute: () => AuthedStaffRoute,
} as any)
const AuthedStaffClientsRoute = AuthedStaffClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AuthedStaffRoute,
} as any)
const AuthedStaffChaseRoute = AuthedStaffChaseRouteImport.update({
  id: '/chase',
  path: '/chase',
  getParentRoute: () => AuthedStaffRoute,
} as any)
const AuthedContractorMyTimesheetRoute =
  AuthedContractorMyTimesheetRouteImport.update({
    id: '/my-timesheet',
    path: '/my-timesheet',
    getParentRoute: () => AuthedContractorRoute,
  } as any)
const AuthedContractorMySubmissionsRoute =
  AuthedContractorMySubmissionsRouteImport.update({
    id: '/my-submissions',
    path: '/my-submissions',
    getParentRoute: () => AuthedContractorRoute,
  } as any)
const AuthedContractorMyInvoicesRoute =
  AuthedContractorMyInvoicesRouteImport.update({
    id: '/my-invoices',
    path: '/my-invoices',
    getParentRoute: () => AuthedContractorRoute,
  } as any)
const AuthedContractorMyCalendarRoute =
  AuthedContractorMyCalendarRouteImport.update({
    id: '/my-calendar',
    path: '/my-calendar',
    getParentRoute: () => AuthedContractorRoute,
  } as any)
const AuthedAdminSettingsRoute = AuthedAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminPaymentsRoute = AuthedAdminPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminInvoicesRoute = AuthedAdminInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminExpensesRoute = AuthedAdminExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminAdminsRoute = AuthedAdminAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedStaffProjectsIdRoute = AuthedStaffProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => AuthedStaffRoute,
} as any)
const AuthedAdminInvoicesIdRoute = AuthedAdminInvoicesIdRouteImport.update({
  id: '/invoices_/$id',
  path: '/invoices/$id',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminExpensesIdRoute = AuthedAdminExpensesIdRouteImport.update({
  id: '/expenses_/$id',
  path: '/expenses/$id',
  getParentRoute: () => AuthedAdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/admins': typeof AuthedAdminAdminsRoute
  '/expenses': typeof AuthedAdminExpensesRoute
  '/invoices': typeof AuthedAdminInvoicesRoute
  '/payments': typeof AuthedAdminPaymentsRoute
  '/settings': typeof AuthedAdminSettingsRoute
  '/my-calendar': typeof AuthedContractorMyCalendarRoute
  '/my-invoices': typeof AuthedContractorMyInvoicesRoute
  '/my-submissions': typeof AuthedContractorMySubmissionsRoute
  '/my-timesheet': typeof AuthedContractorMyTimesheetRoute
  '/chase': typeof AuthedStaffChaseRoute
  '/clients': typeof AuthedStaffClientsRoute
  '/contractors': typeof AuthedStaffContractorsRoute
  '/reports': typeof AuthedStaffReportsRoute
  '/timesheets': typeof AuthedStaffTimesheetsRoute
  '/expenses/$id': typeof AuthedAdminExpensesIdRoute
  '/invoices/$id': typeof AuthedAdminInvoicesIdRoute
  '/projects/$id': typeof AuthedStaffProjectsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/admins': typeof AuthedAdminAdminsRoute
  '/expenses': typeof AuthedAdminExpensesRoute
  '/invoices': typeof AuthedAdminInvoicesRoute
  '/payments': typeof AuthedAdminPaymentsRoute
  '/settings': typeof AuthedAdminSettingsRoute
  '/my-calendar': typeof AuthedContractorMyCalendarRoute
  '/my-invoices': typeof AuthedContractorMyInvoicesRoute
  '/my-submissions': typeof AuthedContractorMySubmissionsRoute
  '/my-timesheet': typeof AuthedContractorMyTimesheetRoute
  '/chase': typeof AuthedStaffChaseRoute
  '/clients': typeof AuthedStaffClientsRoute
  '/contractors': typeof AuthedStaffContractorsRoute
  '/reports': typeof AuthedStaffReportsRoute
  '/timesheets': typeof AuthedStaffTimesheetsRoute
  '/expenses/$id': typeof AuthedAdminExpensesIdRoute
  '/invoices/$id': typeof AuthedAdminInvoicesIdRoute
  '/projects/$id': typeof AuthedStaffProjectsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/activate': typeof ActivateRoute
  '/login': typeof LoginRoute
  '/_authed/_admin': typeof AuthedAdminRouteWithChildren
  '/_authed/_contractor': typeof AuthedContractorRouteWithChildren
  '/_authed/_staff': typeof AuthedStaffRouteWithChildren
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/_admin/admins': typeof AuthedAdminAdminsRoute
  '/_authed/_admin/expenses': typeof AuthedAdminExpensesRoute
  '/_authed/_admin/invoices': typeof AuthedAdminInvoicesRoute
  '/_authed/_admin/payments': typeof AuthedAdminPaymentsRoute
  '/_authed/_admin/settings': typeof AuthedAdminSettingsRoute
  '/_authed/_contractor/my-calendar': typeof AuthedContractorMyCalendarRoute
  '/_authed/_contractor/my-invoices': typeof AuthedContractorMyInvoicesRoute
  '/_authed/_contractor/my-submissions': typeof AuthedContractorMySubmissionsRoute
  '/_authed/_contractor/my-timesheet': typeof AuthedContractorMyTimesheetRoute
  '/_authed/_staff/chase': typeof AuthedStaffChaseRoute
  '/_authed/_staff/clients': typeof AuthedStaffClientsRoute
  '/_authed/_staff/contractors': typeof AuthedStaffContractorsRoute
  '/_authed/_staff/reports': typeof AuthedStaffReportsRoute
  '/_authed/_staff/timesheets': typeof AuthedStaffTimesheetsRoute
  '/_authed/_admin/expenses_/$id': typeof AuthedAdminExpensesIdRoute
  '/_authed/_admin/invoices_/$id': typeof AuthedAdminInvoicesIdRoute
  '/_authed/_staff/projects/$id': typeof AuthedStaffProjectsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/login'
    | '/dashboard'
    | '/admins'
    | '/expenses'
    | '/invoices'
    | '/payments'
    | '/settings'
    | '/my-calendar'
    | '/my-invoices'
    | '/my-submissions'
    | '/my-timesheet'
    | '/chase'
    | '/clients'
    | '/contractors'
    | '/reports'
    | '/timesheets'
    | '/expenses/$id'
    | '/invoices/$id'
    | '/projects/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/login'
    | '/dashboard'
    | '/admins'
    | '/expenses'
    | '/invoices'
    | '/payments'
    | '/settings'
    | '/my-calendar'
    | '/my-invoices'
    | '/my-submissions'
    | '/my-timesheet'
    | '/chase'
    | '/clients'
    | '/contractors'
    | '/reports'
    | '/timesheets'
    | '/expenses/$id'
    | '/invoices/$id'
    | '/projects/$id'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/activate'
    | '/login'
    | '/_authed/_admin'
    | '/_authed/_contractor'
    | '/_authed/_staff'
    | '/_authed/dashboard'
    | '/_authed/_admin/admins'
    | '/_authed/_admin/expenses'
    | '/_authed/_admin/invoices'
    | '/_authed/_admin/payments'
    | '/_authed/_admin/settings'
    | '/_authed/_contractor/my-calendar'
    | '/_authed/_contractor/my-invoices'
    | '/_authed/_contractor/my-submissions'
    | '/_authed/_contractor/my-timesheet'
    | '/_authed/_staff/chase'
    | '/_authed/_staff/clients'
    | '/_authed/_staff/contractors'
    | '/_authed/_staff/reports'
    | '/_authed/_staff/timesheets'
    | '/_authed/_admin/expenses_/$id'
    | '/_authed/_admin/invoices_/$id'
    | '/_authed/_staff/projects/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  ActivateRoute: typeof ActivateRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_staff': {
      id: '/_authed/_staff'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedStaffRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_contractor': {
      id: '/_authed/_contractor'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedContractorRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_admin': {
      id: '/_authed/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_staff/timesheets': {
      id: '/_authed/_staff/timesheets'
      path: '/timesheets'
      fullPath: '/timesheets'
      preLoaderRoute: typeof AuthedStaffTimesheetsRouteImport
      parentRoute: typeof AuthedStaffRoute
    }
    '/_authed/_staff/reports': {
      id: '/_authed/_staff/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedStaffReportsRouteImport
      parentRoute: typeof AuthedStaffRoute
    }
    '/_authed/_staff/contractors': {
      id: '/_authed/_staff/contractors'
      path: '/contractors'
      fullPath: '/contractors'
      preLoaderRoute: typeof AuthedStaffContractorsRouteImport
      parentRoute: typeof AuthedStaffRoute
    }
    '/_authed/_staff/clients': {
      id: '/_authed/_staff/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthedStaffClientsRouteImport
      parentRoute: typeof AuthedStaffRoute
    }
    '/_authed/_staff/chase': {
      id: '/_authed/_staff/chase'
      path: '/chase'
      fullPath: '/chase'
      preLoaderRoute: typeof AuthedStaffChaseRouteImport
      parentRoute: typeof AuthedStaffRoute
    }
    '/_authed/_contractor/my-timesheet': {
      id: '/_authed/_contractor/my-timesheet'
      path: '/my-timesheet'
      fullPath: '/my-timesheet'
      preLoaderRoute: typeof AuthedContractorMyTimesheetRouteImport
      parentRoute: typeof AuthedContractorRoute
    }
    '/_authed/_contractor/my-submissions': {
      id: '/_authed/_contractor/my-submissions'
      path: '/my-submissions'
      fullPath: '/my-submissions'
      preLoaderRoute: typeof AuthedContractorMySubmissionsRouteImport
      parentRoute: typeof AuthedContractorRoute
    }
    '/_authed/_contractor/my-invoices': {
      id: '/_authed/_contractor/my-invoices'
      path: '/my-invoices'
      fullPath: '/my-invoices'
      preLoaderRoute: typeof AuthedContractorMyInvoicesRouteImport
      parentRoute: typeof AuthedContractorRoute
    }
    '/_authed/_contractor/my-calendar': {
      id: '/_authed/_contractor/my-calendar'
      path: '/my-calendar'
      fullPath: '/my-calendar'
      preLoaderRoute: typeof AuthedContractorMyCalendarRouteImport
      parentRoute: typeof AuthedContractorRoute
    }
    '/_authed/_admin/settings': {
      id: '/_authed/_admin/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedAdminSettingsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/payments': {
      id: '/_authed/_admin/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AuthedAdminPaymentsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/invoices': {
      id: '/_authed/_admin/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthedAdminInvoicesRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/expenses': {
      id: '/_authed/_admin/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof AuthedAdminExpensesRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admins': {
      id: '/_authed/_admin/admins'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof AuthedAdminAdminsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_staff/projects/$id': {
      id: '/_authed/_staff/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof AuthedStaffProjectsIdRouteImport
      parentRoute: typeof AuthedStaffRoute
    }
    '/_authed/_admin/invoices_/$id': {
      id: '/_authed/_admin/invoices_/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AuthedAdminInvoicesIdRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/expenses_/$id': {
      id: '/_authed/_admin/expenses_/$id'
      path: '/expenses/$id'
      fullPath: '/expenses/$id'
      preLoaderRoute: typeof AuthedAdminExpensesIdRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
  }
}

interface AuthedAdminRouteChildren {
  AuthedAdminAdminsRoute: typeof AuthedAdminAdminsRoute
  AuthedAdminExpensesRoute: typeof AuthedAdminExpensesRoute
  AuthedAdminInvoicesRoute: typeof AuthedAdminInvoicesRoute
  AuthedAdminPaymentsRoute: typeof AuthedAdminPaymentsRoute
  AuthedAdminSettingsRoute: typeof AuthedAdminSettingsRoute
  AuthedAdminExpensesIdRoute: typeof AuthedAdminExpensesIdRoute
  AuthedAdminInvoicesIdRoute: typeof AuthedAdminInvoicesIdRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminAdminsRoute: AuthedAdminAdminsRoute,
  AuthedAdminExpensesRoute: AuthedAdminExpensesRoute,
  AuthedAdminInvoicesRoute: AuthedAdminInvoicesRoute,
  AuthedAdminPaymentsRoute: AuthedAdminPaymentsRoute,
  AuthedAdminSettingsRoute: AuthedAdminSettingsRoute,
  AuthedAdminExpensesIdRoute: AuthedAdminExpensesIdRoute,
  AuthedAdminInvoicesIdRoute: AuthedAdminInvoicesIdRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedContractorRouteChildren {
  AuthedContractorMyCalendarRoute: typeof AuthedContractorMyCalendarRoute
  AuthedContractorMyInvoicesRoute: typeof AuthedContractorMyInvoicesRoute
  AuthedContractorMySubmissionsRoute: typeof AuthedContractorMySubmissionsRoute
  AuthedContractorMyTimesheetRoute: typeof AuthedContractorMyTimesheetRoute
}

const AuthedContractorRouteChildren: AuthedContractorRouteChildren = {
  AuthedContractorMyCalendarRoute: AuthedContractorMyCalendarRoute,
  AuthedContractorMyInvoicesRoute: AuthedContractorMyInvoicesRoute,
  AuthedContractorMySubmissionsRoute: AuthedContractorMySubmissionsRoute,
  AuthedContractorMyTimesheetRoute: AuthedContractorMyTimesheetRoute,
}

const AuthedContractorRouteWithChildren =
  AuthedContractorRoute._addFileChildren(AuthedContractorRouteChildren)

interface AuthedStaffRouteChildren {
  AuthedStaffChaseRoute: typeof AuthedStaffChaseRoute
  AuthedStaffClientsRoute: typeof AuthedStaffClientsRoute
  AuthedStaffContractorsRoute: typeof AuthedStaffContractorsRoute
  AuthedStaffReportsRoute: typeof AuthedStaffReportsRoute
  AuthedStaffTimesheetsRoute: typeof AuthedStaffTimesheetsRoute
  AuthedStaffProjectsIdRoute: typeof AuthedStaffProjectsIdRoute
}

const AuthedStaffRouteChildren: AuthedStaffRouteChildren = {
  AuthedStaffChaseRoute: AuthedStaffChaseRoute,
  AuthedStaffClientsRoute: AuthedStaffClientsRoute,
  AuthedStaffContractorsRoute: AuthedStaffContractorsRoute,
  AuthedStaffReportsRoute: AuthedStaffReportsRoute,
  AuthedStaffTimesheetsRoute: AuthedStaffTimesheetsRoute,
  AuthedStaffProjectsIdRoute: AuthedStaffProjectsIdRoute,
}

const AuthedStaffRouteWithChildren = AuthedStaffRoute._addFileChildren(
  AuthedStaffRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedContractorRoute: typeof AuthedContractorRouteWithChildren
  AuthedStaffRoute: typeof AuthedStaffRouteWithChildren
  AuthedDashboardRoute: typeof AuthedDashboardRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedContractorRoute: AuthedContractorRouteWithChildren,
  AuthedStaffRoute: AuthedStaffRouteWithChildren,
  AuthedDashboardRoute: AuthedDashboardRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  ActivateRoute: ActivateRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
